<template lang="pug">
  div(class="file-uploader")
    dx-button(text="Elegir Archivo(s)" @click="openFileSelectDialog" v-if="!readOnly && !multiple? value && value.length != 1 : !readOnly")
    .sin-archivos(v-if="value && value.length == 0") Sin archivo(s)
    dx-data-grid(:data-source="value" :allow-column-reordering="true" :row-alternation-enabled="true" 
      :column-auto-width="true" width="100%" height="100%" ref="gridFiles" :show-row-lines="true" :show-borders="true"
      :allow-column-resizing="true" column-resizing-mode="widget" v-if="files && value.length > 0")
  
      dx-scrolling(mode="virtual")

      dx-column(data-field="name" caption="Archivo" dataType="string" cell-template="file")

      template(#file="{data}")
        div
          a.action(title="Eliminar" @click="deleteFile(data.data)" v-if="!readOnly")
            i(class="fas fa-trash-alt")
          a.action(title="Ver/Descargar" @click="showDownloadFile(data.data)" style="margin-left:5px")
            i(class="fas fa-cloud-download-alt")
          i(class="fas fa-check" style="color:green; margin-left:10px" title="Guardado" v-if="data.data.id > 0")
          a.action(style="margin-left:5px" @click="showDownloadFile(data.data)") {{ data.text }}

    input(:id="id" ref="fileInput" type="file" @change="onFileChange" :multiple="multiple" :accept="accept")
</template>
<script>
const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

import { confirm } from "devextreme/ui/dialog";
import MessageBox from "@/components/MessageBox";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    accept: {
      type: String,
      default: "*/*"
    },
    base64Mode: {
      type: Boolean,
      default: true
    },
    maxSizeMb: {
      type: Number,
      default: 3
    },
    maxSizeBlockMb: {
      type: Number,
      default: 10
    }
  },
  components: {
    // Editors
    DxButton: require("devextreme-vue/button").DxButton,
    // Grid
    DxDataGrid: require("devextreme-vue/data-grid").DxDataGrid,
    DxColumn: require("devextreme-vue/data-grid").DxColumn,
    DxScrolling: require("devextreme-vue/data-grid").DxScrolling
  },
  data: () => ({
    files: [],
    id: null,
    changes: false,
    deletedFiles: []
  }),
  mounted() {
    this.id = this._uid;
  },
  methods: {
    getFilesArrayFormData() {
      let archivosData = [];
      this.files.forEach(f => {
        archivosData.push(f.file);
      });
      return archivosData;
    },
    getFiles() {
      return this.files;
    },
    clear() {
      this.deletedFiles = [];
      this.changes = false;
    },
    hasChanges() {
      return this.changes;
    },
    getDeletedFiles() {
      return this.deletedFiles;
    },
    getDeletedFilesId() {
      let deletes = [];
      this.deletedFiles.forEach(d => {
        if (d.id > 0) {
          deletes.push(d.id);
        }
      });
      return deletes;
    },
    openFileSelectDialog() {
      document.getElementById(this.id).click();
    },
    onFileChange(evt) {
      if (!this.multiple) {
        this.files.length = 0;
      }

      let fileInput = this.$refs.fileInput;
      let totalSizeMb = 0;

      evt.target.files.forEach(file => {
        let sizeMb = file.size / 1024 / 1024;
        if (sizeMb > this.maxSizeMb) {
          MessageBox.warning(
            `${file.name} excede el tamaño máximo permitido de ${this.maxSizeMb}MB`
          );
        } else {
          totalSizeMb += sizeMb;
          if (this.base64Mode) {
            toBase64(file)
              .then(base64 => {
                this.files.push({
                  id: null,
                  name: file.name,
                  size: file.size,
                  type: file.type,
                  base64,
                  file: null,
                  downloadUrl: null
                });
                if (this.multiple) {
                  this.$emit("input", this.files);
                  this.$emit("change", this.files);
                } else {
                  this.$emit("input", this.files);
                  this.$emit("change", this.files[0]);
                }
              })
              .catch(err => {
                this.$msg.handleError(err);
              });
          } else {
            this.files.push({
              id: null,
              name: file.name,
              size: file.size,
              type: file.type,
              base64: null,
              file: new File([file], file.name, { type: file.type }),
              downloadUrl: null
            });
            if (this.multiple) {
              this.$emit("input", this.files);
              this.$emit("change", this.files);
            } else {
              this.$emit("input", this.files);
              this.$emit("change", this.files[0]);
            }
          }

          this.changes = true;
        }
      });

      if (totalSizeMb > this.maxSizeBlockMb) {
        MessageBox.warning(
          `Los archivos seleccionados pesan ${totalSizeMb.toFixed(
            2
          )}MB y excede el tamaño máximo permitido de subida por bloque de ${this.maxSizeBlockMb}MB`
        );
        this.files.forEach(f => {
          if (!f.id) {
            this.files.shift();
          }
        });
      }

      fileInput.value = null;
    },
    showDownloadFile(file) {
      if (file.base64) {
        let downloadLink = document.createElement("a");
        let fileName = file.name;

        downloadLink.href = file.base64;
        downloadLink.target = "_blank";
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        window.open(file.downloadUrl, "_blank");
      }
    },
    deleteFile(file) {
      confirm(` ¿Eliminar este registro? `, `Confirmación`)
        .then(ok => {
          if (ok) {
            if (file.id > 0) {
              this.deletedFiles.push(file);
            }
            let indexDelete = -1;
            let index = 0;
            this.value.forEach(f => {
              if (f.name == file.name && f.size == file.size) {
                indexDelete = index;
              }
              index++;
            });
            if (indexDelete != -1) {
              this.value.splice(indexDelete, 1);
              this.$emit("deleting", file.id);
            }
          }
        })
        .catch(err => {
          MessageBox.handleError(err);
        });
    }
  }
};
</script>
<style scoped>
.file-uploader > input[type="file"] {
  display: none;
}
.sin-archivos {
  min-height: 36px;
  align-items: center;
  display: flex;
  padding: 7px 9px;
  box-sizing: border-box;
  border: 1px dashed #ddd;
  border-radius: 4px;
  width: 100%;
}

.file-uploader > * {
  display: inline-block;
}
</style>
